import { BemContext } from "./BemContext";
import { useContext, useMemo } from "react";
import {
    bemBlock,
    IBemElement,
    IBemPrefixedElementContainer,
} from "@ngd-web/lv-utils/ui/bemHelper";

export function useBemContext(): IBemPrefixedElementContainer {
    const bemContext = useContext(BemContext);
    if (typeof bemContext === "object") return bemContext;

    const [bl, el] = bemBlock("");
    return { bl, el: el.prefixed("") };
}

export const useElFromBemContext = (el = null as IBemElement): IBemElement =>
    useMemo(() => (el ? () => el : () => useBemContext().el), [])();

export const useBemBlock = (className: string) =>
    useMemo(() => bemBlock(className), [className]);

export const useBemSubBlock = (el: IBemElement, postfix: string) =>
    useMemo(() => el.subBlock(postfix), [el, postfix]);

export const usePrefixedBem = (el: IBemElement, prefix: string) =>
    useMemo(() => el.prefixed(prefix), [el, prefix]);

export const useBem = (el: IBemElement, name: string, ...mods: string[]) =>
    useMemo(() => el(name, ...mods), [el, name, ...mods]);
